export default __webpack_public_path__ + "static/media/x-ray-room-correct.974e56b0.jpeg";